import React from 'react';
import './ShapePicker.css';

interface ShapePickerProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
  type: 'module' | 'corner' | 'eye';
  tooltip?: string;
}

const renderShapeSvg = (shape: string, type: 'module' | 'corner' | 'eye') => {
  if (type === 'module') {
    switch (shape) {
      case 'square': return <rect x="2" y="2" width="20" height="20" fill="black" />;
      case 'rounded': return <rect x="2" y="2" width="20" height="20" rx="4" fill="black" />;
      case 'dots': return <circle cx="12" cy="12" r="10" fill="black" />;
      case 'classy': return <path d="M2 12A10 10 0 0 1 12 2A10 10 0 0 1 22 12H12Z" fill="black" />; // Approximate
      case 'classy-rounded': return <path d="M2 12A10 10 0 0 1 12 2H22V12A10 10 0 0 1 12 22H2Z" fill="black" />; // Approximate
      case 'extra-rounded': return <rect x="2" y="2" width="20" height="20" rx="10" fill="black" />;
      default: return <rect x="2" y="2" width="20" height="20" fill="black" />;
    }
  } else if (type === 'corner') {
    switch (shape) {
      case 'square': return <path d="M2 2h20v20H2zm4 4v12h12V6z" fill="black" fillRule="evenodd" />;
      case 'extra-rounded': return <path d="M12 2a10 10 0 0 1 10 10v10H12A10 10 0 0 1 2 12V2z" fill="black" />; // simplified
      case 'dot': return <circle cx="12" cy="12" r="10" fill="none" stroke="black" strokeWidth="4" />;
      default: return <path d="M2 2h20v20H2zm4 4v12h12V6z" fill="black" fillRule="evenodd" />;
    }
  } else {
    switch (shape) {
      case 'square': return <rect x="6" y="6" width="12" height="12" fill="black" />;
      case 'dot': return <circle cx="12" cy="12" r="6" fill="black" />;
      default: return <rect x="6" y="6" width="12" height="12" fill="black" />;
    }
  }
};

export const ShapePicker: React.FC<ShapePickerProps> = ({ options, value, onChange, label, type, tooltip }) => {
  return (
    <div className="shape-picker-container" role="radiogroup" aria-label={label ?? type}>
      {label && (
        <span className="shape-picker-label" title={tooltip ?? undefined}>
          {label}
        </span>
      )}
      <div className="shape-picker-grid">
        {options.map((shape) => (
          <button
            key={shape}
            className={`shape-tile ${value === shape ? 'active' : ''}`}
            onClick={() => { onChange(shape); }}
            aria-label={shape}
            title={shape.charAt(0).toUpperCase() + shape.slice(1).replace('-', ' ')}
            role="radio"
            aria-checked={value === shape}
          >
            <svg viewBox="0 0 24 24" width="24" height="24">
              {renderShapeSvg(shape, type)}
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
};
